// `_isUndefined` : an object's function
// --------------------------------------

// Is a given variable undefined?
export default function (obj) {
	return obj === void 0;
}